import { Dialog } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import TermsAndPolicy from "./TermsAndPolicy";
import useIsMobile from "../../utils/detectDevice";

function Footer() {
  const [dialogState, setDialogState] = useState<{
    open: boolean;
    header: string;
  }>({ open: false, header: "" });
  const { isMobile } = useIsMobile();
  return (
    <>
      <Dialog
        open={dialogState.open}
        onClose={() => setDialogState({ header: "", open: false })}
      >
        <TermsAndPolicy
          type={dialogState.header}
          onClose={() => setDialogState({ header: "", open: false })}
        />
      </Dialog>
      <footer
        className={` ${
          isMobile
            ? "flex flex-col items-center"
            : "md:flex md:items-center md:justify-between md:p-6"
        }`}
      >
        <span className="text-sm text-gray-500 sm:text-center ">
          © 2022{" "}
          <a
            onClick={() =>
              setDialogState({ open: true, header: "Terms And Services" })
            }
            className="cursor-pointer hover:underline"
          >
            Hissa™
          </a>
          . All Rights Reserved.
        </span>
        <ul className="flex flex-wrap items-center mt-3 text-sm text-gray-500 sm:mt-0">
          <li></li>
          <li>
            <a
              onClick={() =>
                setDialogState({ open: true, header: "Privacy Policy" })
              }
              className="mr-4 cursor-pointer hover:underline md:mr-6"
            >
              Privacy Policy
            </a>
          </li>
          <li>
            <a
              onClick={() =>
                setDialogState({ open: true, header: "Terms And Services" })
              }
              className="cursor-pointer hover:underline"
            >
              Terms and Conditions
            </a>
          </li>
        </ul>
      </footer>
    </>
  );
}

export default Footer;
